import {
    CREATE_PRINTING2_INWARD_DETAILS_REQUEST_DK,
    CREATE_PRINTING2_INWARD_DETAILS_SUCCESS_DK,
    CREATE_PRINTING2_INWARD_DETAILS_FAILURE_DK,
    DELETE_PRINTING2_INWARD_DETAILS_REQUEST_DK,
    DELETE_PRINTING2_INWARD_DETAILS_SUCCESS_DK,
    DELETE_PRINTING2_INWARD_DETAILS_FAILURE_DK,
    FETCH_SINGLE_PRINTING2_INWARD_DETAILS_REQUEST_DK,
    FETCH_SINGLE_PRINTING2_INWARD_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_PRINTING2_INWARD_DETAILS_FAILURE_DK,
    FETCH_PRINTING2_INWARD_DETAILS_REQUEST_DK,
    FETCH_PRINTING2_INWARD_DETAILS_SUCCESS_DK,
    FETCH_PRINTING2_INWARD_DETAILS_FAILURE_DK,
    UPDATE_PRINTING2_INWARD_DETAILS_REQUEST_DK,
    UPDATE_PRINTING2_INWARD_DETAILS_SUCCESS_DK,
    UPDATE_PRINTING2_INWARD_DETAILS_FAILURE_DK,
    RESET_PRINTING2_INWARD_DETAILS_INFO_DK,
    CREATE_PRINTING2_INWARD_DETAILS_FORM_DK,
    UPDATE_PRINTING2_INWARD_DETAILS_FORM_DK,
    FETCH_PRINTING2_INWARD_DETAILS_WITHOUT_ID_SUCCESS_DK,
    FETCH_PREVIOUS_PRINTING2_INWARD_DETAILS_REQUEST_DK,
    FETCH_PREVIOUS_PRINTING2_INWARD_DETAILS_SUCCESS_DK,
    FETCH_PREVIOUS_PRINTING2_INWARD_DETAILS_FAILURE_DK
} from './printing2InwardDetails.actionsType';

export const PRINTING2_INWARD_DK_DETAILS = 'printing2InwardDKDetails';

let initialState = {
    loading: false,
    printing2InwardDetails: [],
    printing2InwardDetailsWithoutId: [],
    previousGetList: [],
    printing2InwardDetailsForm: {
        fldRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        // fldReceivingRolls: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0,
        fldDiscountPercentage: 0,
        fldPOQuantity: 0,
        fldInwardQuantity: 0
    },
    selectedState: {},
    errorMessage: ''
};

export let printing2InwardDKDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_PRINTING2_INWARD_DETAILS_REQUEST_DK:
        case FETCH_PREVIOUS_PRINTING2_INWARD_DETAILS_REQUEST_DK:
        case CREATE_PRINTING2_INWARD_DETAILS_REQUEST_DK:
        case UPDATE_PRINTING2_INWARD_DETAILS_REQUEST_DK:
        case FETCH_SINGLE_PRINTING2_INWARD_DETAILS_REQUEST_DK:
        case DELETE_PRINTING2_INWARD_DETAILS_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_PRINTING2_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printing2InwardDetails: updatePayload
            };
        case FETCH_PREVIOUS_PRINTING2_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                previousGetList: updatePayload?.IPI
            };
        case FETCH_PRINTING2_INWARD_DETAILS_WITHOUT_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printing2InwardDetailsWithoutId: updatePayload
            };
        case CREATE_PRINTING2_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printing2InwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    // fldReceivingRolls: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                }
            };
        case UPDATE_PRINTING2_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printing2InwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    // fldReceivingRolls: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                }
            };
        case FETCH_SINGLE_PRINTING2_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printing2InwardDetailsForm: updatePayload
            };
        case DELETE_PRINTING2_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printing2InwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    // fldReceivingRolls: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                }
            };
        case RESET_PRINTING2_INWARD_DETAILS_INFO_DK:
            return {
                ...state,
                printing2InwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    // fldReceivingRolls: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                }
            };
        case CREATE_PRINTING2_INWARD_DETAILS_FORM_DK:
        case UPDATE_PRINTING2_INWARD_DETAILS_FORM_DK:
            return {
                ...state,
                loading: false,
                printing2InwardDetailsForm: {
                    ...state.printing2InwardDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_PRINTING2_INWARD_DETAILS_FAILURE_DK:
        case FETCH_PREVIOUS_PRINTING2_INWARD_DETAILS_FAILURE_DK:
        case CREATE_PRINTING2_INWARD_DETAILS_FAILURE_DK:
        case UPDATE_PRINTING2_INWARD_DETAILS_FAILURE_DK:
        case FETCH_SINGLE_PRINTING2_INWARD_DETAILS_FAILURE_DK:
        case DELETE_PRINTING2_INWARD_DETAILS_FAILURE_DK:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
